<template>
  <v-app-bar
    color="primary"
    elevation="0"
  >
    <v-row
      no-gutters
      align="center"
    >
      <v-col
        cols="3"
        sm="1"
        md="1"
      >
        <v-img
          class="ma-0"
          aspect-ratio="1"
          :src="require('@/assets/primary.png')"
        />
      </v-col>
    </v-row>
    <v-spacer />
    <v-app-bar-nav-icon
      color="white"
      @click="$emit('drawerCtrl')"
    />
  </v-app-bar>
</template>

<script>
export default {

}
</script>

<style>

</style>
